module.exports = __webpack_public_path__ + "static/img/50.c78b757f.jpeg";